import * as React from 'react';
import DraggerButton from './components/dragger-button';
import Upload from './upload';
import type { UploadHandle, UploadProps } from './upload.types';
import hoistNonReactStatics from 'hoist-non-react-statics';

export type DraggerProps = UploadProps & {};

const Dragger = (
  { style, children, ...restProps }: DraggerProps & { children: React.ReactNode },
  ref?: React.Ref<UploadHandle>,
) => {
  return (
    <Upload ref={ref} {...restProps} type="drag" style={style}>
      {children}
    </Upload>
  );
};

Dragger.Button = DraggerButton;

export default hoistNonReactStatics(React.forwardRef(Dragger), Dragger);
